import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StayPrimaryLandscapeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stay_primary_landscape"}/>
}
